//@flow
import React from "react"
import { FormattedMessage } from "react-intl"
import { Layer } from "../UI/Page"
import { Flex, Box } from "grid-styled"
import { SearchListView } from "../SearchTableView"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityPrimaryLink,
  EntityAction
} from "../UI/EntityList"
import { H2 } from "../UI/Headings"
import { queries } from "../Sensors"
import type { SensorListQuery } from "../Sensors"

type SectionProps = {
  push: Function
}

type SensorListProps = {
  sensors: SensorListQuery,
  handleSearch: Function,
  searchName: string,
  push: Function
}

const SensorList = ({
  sensors: { sensors, loading },
  handleSearch,
  searchName,
  push
}: SensorListProps) => (
  <SearchListView
    handleSearch={handleSearch}
    searchName={searchName}
    query={searchName}
    entityName="Sensors"
    loading={loading}
  >
    <EntityHeading>
      <EntityDetail grow={2}>Name</EntityDetail>
      <EntityDetail grow={1}>Serial</EntityDetail>
      <EntityDetail grow={1} shrink={0} />
    </EntityHeading>
    {sensors &&
      sensors.map(sensor => (
        <Entity key={sensor.id}>
          <EntityDetail grow={2}>
            <EntityPrimaryLink to={`/admin/sensors/${sensor.id || "new"}`}>
              {sensor.friendlyName || sensor.stationName}
            </EntityPrimaryLink>
          </EntityDetail>
          <EntityDetail grow={1}>{sensor.serialNumber}</EntityDetail>
          <EntityDetail grow={1} shrink={0} row end>
            <EntityAction
              href="#"
              onClick={() => push(`/admin/sensors/${sensor.id || "new"}`)}
              icon="✏️"
            />
          </EntityDetail>
        </Entity>
      ))}
  </SearchListView>
)

const SensorListWithData = queries.withSensors(SensorList)

type State = { query: string }

class SensorsSection extends React.Component<SectionProps, State> {
  constructor(props: SectionProps) {
    super(props)
    this.state = { query: "" }
  }

  handleSearch = (query: string) => this.setState(() => ({ query }))

  render() {
    const { push } = this.props
    const { query } = this.state

    return (
      <Layer>
        <Flex w="100%" wrap>
          <Box w={[1, 1 / 2, 1 / 3, null]} pr={[0, 2]}>
            <H2>
              <FormattedMessage id="admin.dashboard.sensors.title" />
            </H2>
            <p>
              <FormattedMessage id="admin.dashboard.sensors.description" />
            </p>
          </Box>
          <Box w={[1, 1 / 2, 2 / 3]}>
            <SensorListWithData
              push={push}
              searchName={query}
              handleSearch={this.handleSearch}
            />
          </Box>
        </Flex>
      </Layer>
    )
  }
}

export default SensorsSection



// WEBPACK FOOTER //
// ./src/Home/SensorsSection.js